export const getLanguage = locale => {
  if (!locale) {
    return 'en';
  }
  const language = locale.toLowerCase().substr(0, 2);
  if (language === 'en' || language === 'de') {
    return language;
  }
  return 'en';
};



// WEBPACK FOOTER //
// ./src/utils/languages.js